import ClaimDetails from "./ClaimDetails";
export default ClaimDetails;
